import React from 'react';

import { STOCheckBasket } from 'commons/types';
import { TableConfig } from 'commons/types/tableConfig.interface';

const formatElement = (
  input?: number[] | number | string,
  bold = false,
): React.JSX.Element => {
  const text = input?.toString();
  return <div style={{ fontWeight: bold ? '700' : '400' }}>{text}</div>;
};

export const stoDataConfig: TableConfig = [
  {
    header: 'Sto Number',
    key: 'sto_number',
  },
  {
    header: 'Basket Number',
    element: (task: STOCheckBasket): React.ReactElement => {
      return formatElement(task.basket);
    },
  },
  {
    header: 'Picker',
    element: (task: STOCheckBasket): React.ReactElement => {
      return formatElement(task.picker || '-');
    },
  },
  {
    header: 'Total SKU',
    element: (task: STOCheckBasket): React.ReactElement => {
      return formatElement(task.total_sku, true);
    },
  },
  {
    header: 'Total QTY',
    element: (task: STOCheckBasket): React.ReactElement => {
      const totalQty = task.items.reduce(
        (total, item) => total + item.quantity,
        0,
      );
      const pickActualQty = task.items.reduce((total, item) => {
        return (
          total +
          item.pick_actual.reduce((itemTotal, pickActual) => {
            return itemTotal + pickActual.quantity;
          }, 0)
        );
      }, 0);
      return formatElement(`${pickActualQty}/${totalQty}`);
    },
  },
];
